import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ExperienceHighlight = () => {
  const stats = [
    { label: "Years Experience", value: "4.5+", icon: "Calendar" },
    { label: "Projects Completed", value: "40+", icon: "CheckCircle" },
    { label: "Happy Clients", value: "30+", icon: "Users" },
    { label: "Technologies Mastered", value: "10+", icon: "Code" }
  ];

  const highlights = [
    {
      id: 1,
      role: 'Senior MERN Stack Developer | Technical Consultant',
      company: 'Cosmic Info Solution',
      location: 'Surat, IN',
      period: '2023 - Present',
      type: 'Full-time',
      logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop',
      description: `Primary technical point of contact for clients, leading discovery calls to understand workflows and translating them into actionable software requirements, while owning full project lifecycles.`,
      achievements: [
        'Advise clients on digital transformation strategy and modern web architecture',
        'Design scalable frontend and backend architectures on the MERN stack',
        'Plan and manage project roadmaps with predictable delivery',
        'Handle server management, deployment, and performance optimization',
        'Provide ongoing client support and solution consulting'
      ],
      technologies: ['JavaScript', 'React', 'Node.js', 'Express.js', 'MongoDB', 'AWS', 'REST APIs', 'System Architecture'],
      current: true
    },
    {
      id: 2,
      role: 'Lead MERN Stack Developer, Project: KiviCare MERN',
      company: 'Iqonic Design',
      location: 'Surat, IN',
      period: '2021 - 2023',
      type: 'Full-time',
      logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop',
      description: `Led the ground-up MERN Stack implementation of KiviCare, a healthcare management product originally built on WordPress. Owned the project from requirement analysis through production release.`,
      achievements: [
        'Designed the overall solution architecture including database schema and REST APIs',
        'Led sprint planning, task breakdown, and code review for the development team',
        'Directed development of core modules including Patient, Doctor, and Appointment Management',
        'Successfully delivered the complete MERN implementation within a one-month timeline'
      ],
      technologies: ['React', 'Node.js', 'Express.js', 'MongoDB', 'Mongoose', 'REST APIs', 'WordPress', 'Laravel'],
      current: false
    }
  ];

  return (
    <section className="py-20 bg-muted/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-medium mb-6">
            <Icon name="Briefcase" size={16} className="mr-2" />
            Professional Journey
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-6">
            Experience & Achievements
          </h2>

          <p className="text-lg text-text-secondary max-w-2xl mx-auto mb-8">
            Proven track record of delivering high-quality solutions and driving technical excellence
            across diverse projects and industries.
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-surface rounded-lg p-6 text-center border border-border hover:shadow-lg transition-all duration-300"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 bg-primary/10 text-primary rounded-full mb-4">
                <Icon name={stat.icon} size={24} />
              </div>
              <div className="text-2xl md:text-3xl font-bold text-text-primary mb-2">{stat.value}</div>
              <div className="text-sm text-text-secondary">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Experience Timeline */}
        <div className="space-y-8 mb-12">
          {highlights.map((experience, index) => (
            <div
              key={index}
              className="bg-surface rounded-xl p-6 md:p-8 border border-border hover:shadow-lg transition-all duration-300"
            >
              <div className="mb-4">
                <h3 className="text-lg font-bold text-text-primary mb-3 break-words">{experience.role}</h3>
                <div className="flex items-center justify-between">
                  <div className="flex items-center text-primary font-medium">
                    <Icon name="Building" size={16} className="mr-2" />
                    {experience.company}
                  </div>
                  <div className="flex items-center text-text-secondary">
                    <Icon name="Calendar" size={16} className="mr-2" />
                    {experience.period}
                  </div>
                </div>
              </div>

              <p className="text-text-secondary mb-4">{experience.description}</p>

              <div className="space-y-2">
                <h4 className="font-semibold text-text-primary">Key Achievements:</h4>
                <ul className="space-y-1">
                  {experience.achievements.map((achievement, idx) => (
                    <li key={idx} className="flex items-center text-text-secondary">
                      <Icon name="CheckCircle" size={16} className="mr-2 text-success flex-shrink-0" />
                      {achievement}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link to="/experience">
            <Button variant="outline" size="lg" iconName="ArrowRight" iconPosition="right" className="w-full sm:w-auto border-2 border-slate-300 dark:border-input">
              View Full Experience
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ExperienceHighlight;